// (function() {
//     const toggleHeadingElements = document.getElementsByClassName("kg-toggle-heading");

//     const toggleFn = function(event) {
//         const targetElement = event.target;
//         const parentElement = targetElement.closest('.kg-toggle-card');
//         var toggleState = parentElement.getAttribute("data-kg-toggle-state");
//         if (toggleState === 'close') {
//             parentElement.setAttribute('data-kg-toggle-state', 'open');
//         } else {
//             parentElement.setAttribute('data-kg-toggle-state', 'close');
//         }
//     };

//     for (let i = 0; i < toggleHeadingElements.length; i++) {
//         toggleHeadingElements[i].addEventListener('click', toggleFn, false);
//     }
// })();


(function() {
    const hiwBtns = document.querySelectorAll('.hiw-btn');

    hiwBtns.forEach(function(hiwBtn) {
        const hiwCardVisual = hiwBtn.closest('.hiw-card').querySelector('.hiw-card-visual');
        const featuresListContent = hiwBtn.closest('.hiw-card').querySelector('.features-list-content');
        const featuresListSteps = hiwBtn.closest('.hiw-card').querySelector('.reporting-steps');


        // Add a click event listener to the button
        hiwBtn.addEventListener('click', function () {
            // Toggle the visibility of hiw-card-visual and features-list-content
            hiwCardVisual.classList.toggle('hidden');
            featuresListContent.classList.toggle('hidden');
            featuresListSteps.classList.toggle('hidden');
            hiwBtn.classList.toggle('rotate');
        });
    });
})();


(function () {
    // Accordion Functionality
    // document.querySelectorAll('.accordian-title').forEach(function (title) {
    //     title.addEventListener('click', function (e) {
    //         e.stopPropagation();
            
    //         const parent = this.parentElement;
    //         const content = parent.querySelector('.accordian-content');
            
    //         // Toggle active class and inline styles for the current accordion
    //         const isActive = parent.classList.toggle('active');
    //         if (isActive) {
    //             content.style.display = 'block'; // Show content
    //             content.style.maxHeight = content.scrollHeight + "px"; // Open accordion

    //             // Scroll to content smoothly with offset for fixed header (if any)
    //             const offset = document.querySelector('header')?.offsetHeight || 0;
    //             const topPos = content.getBoundingClientRect().top + window.pageYOffset - offset - 10;
    //             window.scrollTo({ top: topPos, behavior: 'smooth' });
    //         } else {
    //             content.style.maxHeight = null; // Close accordion
    //             content.style.display = 'none';
    //         }
            
    //         // Close siblings' accordions
    //         const siblings = Array.from(parent.parentElement.children).filter(el => el !== parent);
    //         siblings.forEach(function (sibling) {
    //             sibling.classList.remove('active');
    //             const siblingContent = sibling.querySelector('.accordian-content');
    //             if (siblingContent) {
    //                 siblingContent.style.maxHeight = null; // Reset maxHeight
    //                 siblingContent.style.display = 'none'; // Hide content
    //             }
    //         });
    //     });
    // });


    // Smooth Scroll Functionality
    document.querySelectorAll('.scroll-item').forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            const id = this.getAttribute('href');
            const target = document.querySelector(id);

            if (target) {
                window.scrollTo({
                    top: target.offsetTop,
                    behavior: 'smooth' // Smooth scrolling
                });
            }
        });
    });
})();




//  const languages = [
//     {index:0,code:'en',name:'EN'},
//     {index:1,code:'nl',name:'NL'},
//     {index:2,code:'es',name:'ES'},
//     {index:3,code:'de',name:'DE'},
//     {index:4,code:'pt',name:'PT'},
//     {index:5,code:'tr',name:'TR'}
// ];
// const currentUrl = window.location.href;
// let currentLanguage = null;

// function getLocaleUrl(url,language){
//     if(url && language){
//         let tmpUrl = new URL(url);
//         if(tmpUrl && tmpUrl.pathname){
//             let languageFound = false;
//             languages.forEach(lang => {
//                 if(language.code=='en'){
//                     tmpUrl.pathname = tmpUrl.pathname.replace(`/${lang.code}/`,`/`);
//                     languageFound = true;
//                 }

//                 if(tmpUrl.pathname.includes(`/${lang.code}/`)){
//                     tmpUrl.pathname = tmpUrl.pathname.replace(`/${lang.code}/`,`/${language.code}/`);
//                     languageFound = true;
//                 }
//             });

//             if(!languageFound && language.code!= 'en'){
//                 tmpUrl.pathname = `/${language.code}`+tmpUrl.pathname;
//             }
//         }
//         return tmpUrl.toString();
//     }
// }

// if(currentUrl){
//     languages.forEach(language => {
//         if(currentUrl.includes(`/${language.code}/`)){
//             currentLanguage = language;
//         }else{
//             const localeUrl = getLocaleUrl(currentUrl,language);
//             document.querySelector('.language-dropdown').insertAdjacentHTML('beforeend',`<li class="${language.code}"><a href="${localeUrl}" class="language-btn btn btn-round">${language.name}</a></li>`)
//         }
//     });
// }
// if(currentLanguage){
//     document.querySelector('a.gh-head-logo').href=`{{@site.url}}/${currentLanguage.code}/`;

//     document.querySelector('.lbl-language').innerHTML = currentLanguage.name;
//     const urls = document.querySelectorAll('.footer-navigation a,.gh-head-menu .nav li a');
//     if(urls){
//         urls.forEach(url => {
//             const label = url.innerHTML;
//             if(url.href.includes('{{@site.url}}') && url.pathname.length>1 && !url.className.includes('language')  && !url.href.includes(`/${currentLanguage.code}/`)){
//                 url.href = url.href.replace('{{@site.url}}/',`{{@site.url}}/${currentLanguage.code}/`)
//             }
//         });
//     }
// }else{
//     document.querySelector('.language-dropdown li.en').style.display='none';
// }





